import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { Entitlements } from '../../types';
import { AxiosErrorCodes } from '../../types/AxiosErrorCodes';
import { fetchEntitlementsData } from '../services/artifactServices';

export const useEntitlementsData = (options?: { enabled?: boolean }) =>
  useQuery<Entitlements>({
    queryKey: ['entitlementsData'],
    queryFn: fetchEntitlementsData,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
    enabled: options?.enabled ?? true,
    retry: (failureCount, error) => {
      // retry only if the error is a 500 status code or it times out
      console.log('retry error:', error);
      const is500Error = (error as AxiosError).response?.status === 500;
      const isTimeoutError =
        (error as AxiosError).code === AxiosErrorCodes.ETIMEDOUT;

      if (is500Error || isTimeoutError) {
        // retry only once
        return failureCount < 1;
      }
      return false;
    },
  });
